import PropTypes from 'prop-types'
import Access from '../context/Access'
import Maintenance from './Maintenance'

import { useAuthContext } from './AuthProvider'

const AuthWall = ({ children }) => {
  const { isLoggedIn } = useAuthContext()
  const IS_MAINTENANCE = process.env.REACT_APP_IS_MAINTENANCE

  return IS_MAINTENANCE==='1' ? <Maintenance /> : isLoggedIn ? children : <Access />
}
AuthWall.propTypes = {
  children: PropTypes.element.isRequired,
}

export default AuthWall
